import React from 'react';
import { useGlobalLoading } from '../../hooks/useLoading';

const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
};


const Loading: React.FC = () => {
    const { loading } = useGlobalLoading();
    return (
        
            loading && <div style={overlayStyle}>
                <img
                src={`/threeCircle.svg`}
                style={{ width: '60px' }}
                alt='Loading...'
                />
            </div>
        
    )
}

export default Loading;